import React, { useState, useEffect } from 'react'
import useModal from 'hook/useModal'

// css
import 'assets/style/components/bottom-sheet.scss'

// elements
import Button from 'components/elements/Button'
import Heading from 'components/elements/Heading'
import IconButton from 'components/elements/IconButton'
import Text from 'components/elements/Text'

/**
 * BottomSheet parameters
 * @children {Object}  - 바텀 시트 내부 dom
 * @list {Array}  - 선택 리스트가 있는 경우
 * @show {Boolean}  - [true | false]
 * @onCancel {Function}  - 부모에서 전달 받는 열림 닫힘 제어 함수
 */
function Element({ show = false, onCancel, className = '', children, title = '', list = [], onClick = () => {} }) {
  return (
    <section className={`bottom-sheet-wrap  ${[true, 'true'].includes(show) ? 'show' : 'hide'} ` + className}>
      <div className="popup-dim" onClick={() => onCancel(false)}></div>
      <section className={`bottom-sheet-area ` + className}>
        <span className="close" onClick={() => onCancel(false)}></span>
        <Heading level="2" text={title} />
        <div className="body">{children}</div>
        <div className="list-area">
          {list.map((item) => (
            <Text
              className={`list-item ${item.active === true ? ' active' : ''}`}
              onClick={() => onClick(item)}
              key={item._key}
            >
              {item.text}
            </Text>
          ))}
          {list.length === 0 && (
            <Text className="flex py10 flex-center f-14 mono-b" text="대상 사이트 정보가 없습니다." />
          )}
        </div>
      </section>
    </section>
  )
}

export default Element
